namespace $ {
	/** Groups and skills live in separate areas; the catalogue stores links only. */
	export class $shm_hitalama_skills_entry extends $giper_baza_entity.with({
		Kind: $giper_baza_atom_text,
		Parent: $giper_baza_atom_text,
		Name: $giper_baza_atom_text,
		Document: $giper_baza_atom_text,
		Files: $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $giper_baza_file ) ),
	}) {
		group() { return this.Kind()?.val() === 'group' }
		name() {
			return this.$.$mol_error_fence( ()=> {
				const name = this.$.$shm_hitalama_skills_yaml.read( this.document() ).data.name
				return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test( name ) && name.length <= 64 ? name : this.Name()?.val() ?? ''
			}, ()=> this.Name()?.val() ?? '' )
		}
		document( next?: string ): string {
			if( next !== undefined ) return this.file_write( 'SKILL.md', next )
			const file = this.file( 'SKILL.md' )
			return file ? this.read_file( file ) : this.Document()?.val() ?? ''
		}
		file( path: string ) { return this.Files()?.key( this.$.$shm_hitalama_skills_yaml.path( path ) )?.remote() ?? null }
		paths() { return [ ...new Set([ 'SKILL.md', ...( this.Files()?.keys().map( String ) ?? [] ) ]) ].sort( ( a, b )=> a === 'SKILL.md' ? -1 : b === 'SKILL.md' ? 1 : a.localeCompare( b ) ) }
		file_text( path: string ) {
			if( path === 'SKILL.md' ) return this.document()
			const file = this.file( path )
			return file ? this.read_file( file ) : ''
		}
		read_file( file: $giper_baza_file ) {
			// A not-yet-loaded remote file must not look like an editable empty document.
			this.$.$shm_hitalama_map_component_ready.read( file )
			const chunks = file.Chunks()
			if( chunks ) this.$.$shm_hitalama_map_component_ready.read( chunks )
			return file.str()
		}
		@ $mol_action
		file_write( path: string, text: string ) {
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение скилла.' )
			this.$.$shm_hitalama_skills_yaml.path( path )
			if( new TextEncoder().encode( text ).length > 1048576 ) throw new Error( 'Файл больше 1 МиБ.' )
			if( this.file( path ) && this.file_text( path ) === text ) return text
			const file = $mol_wire_sync( this ).file_allocate( path )
			file.str( text ); file.name( path )
			this.Files( null )!.key( path, null )!.remote( file )
			if( path === 'SKILL.md' && this.Document()?.val() ) this.Document( null )!.val( '' )
			return text
		}
		// Publish one immutable file snapshot through an atom. Concurrent whole-file
		// saves must select a version, not merge two lists of binary chunks.
		file_allocate( path: string ) { return this.land().area_make().Data( this.$.$giper_baza_file ) }
		@ $mol_action
		file_remove( path: string ) {
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение скилла.' )
			if( path === 'SKILL.md' ) throw new Error( 'SKILL.md нельзя удалить отдельно от скилла.' )
			this.Files()?.key( path, null )?.remote( null )
		}
		metadata() { return this.$.$shm_hitalama_skills_yaml.parse( this.document() ) }
	}
}
